import React from "react";

export default function Footer({ onBack }) {
  return (
    <div>
      {/* FOOTER */}
      <footer className="page-footer" style={{ backgroundColor: "#fff6fa" }}>
        <br />
        <div className="container">
          <div className="row">
            <div className="col s12 m6 l4">
              <h5 className="boxx">Contacto</h5>
              <ul>
                <li>
                  <a className="boxx" href="mailto:fundacionsoffy@gmail.com">
                    fundacionsoffy@gmail.com
                  </a>
                </li>
                <li>
                  <a className="boxx" href="tel:4422430535">
                    Tel: 442 243 0535
                  </a>
                </li>
                <li>
                  <a
                    className="boxx"
                    href="https://wa.me/524446513754?text=Hola,%20me%20gustaría%20obtener%20más%20información%20sobre%20Fundación%20Soffy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Whatsapp: 444 651 3754
                  </a>
                </li>

                <li>
                  <span className="boxx">
                    Dirección: Av. Calzada de Belén 537, <br />
                    Col. Lomas de San Pedrito Peñuelas, <br />
                    C.P. 76148, Querétaro, Querétaro.
                  </span>
                </li>
              </ul>
            </div>

            <div className="col s12 m6 l4">
              <h5 className="boxx">Redes Sociales</h5>
              <ul style={{ flexWrap: "wrap", gap: "1rem" }}>
                <li>
                  <a
                    href="https://www.facebook.com/FUNDACIONSOFFYUnaManoAmigaAC"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="boxx"
                    title="Facebook"
                  >
                    <i className="fab fa-facebook-f"></i> &nbsp;&nbsp;Fundación
                    SOFFY
                  </a>
                </li>
                <li>
                  <a
                    href="https://x.com/fundacion_soffy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="boxx"
                    title="Twitter"
                  >
                    <i className="fab fa-twitter"></i>&nbsp;&nbsp;fundacion_soffy
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/fundacionsoffy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="boxx"
                    title="Instagram"
                  >
                    <i className="fab fa-instagram"></i>&nbsp;&nbsp;fundacionsoffy
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/@fundacionsoffy4246/videos"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="boxx"
                    title="YouTube"
                  >
                    <i className="fab fa-youtube"></i>&nbsp;&nbsp;Fundación Soffy
                  </a>
                </li>
                <li>
                  <a
                    href="https://mx.linkedin.com/in/fundaci%C3%B3n-soffy-586703257"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="boxx"
                    title="LinkedIn"
                  >
                    <i className="fab fa-linkedin-in"></i>&nbsp;&nbsp;Fundación
                    Soffy, una mano amiga A. C.
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.tiktok.com/discover/fundacion-soffy-queretaro"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="boxx"
                    title="TikTok"
                  >
                    <i className="fab fa-tiktok"></i>&nbsp;&nbsp;fundacionsoffy
                  </a>
                </li>
              </ul>
            </div>

            <div className="col s12 m6 l4">
              <h5 className="boxx">Partes interesadas externas en salud</h5>
              <ul>
                <li>
                  <a
                    className="boxx"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.gob.mx/cenatra"
                  >
                    Centro Nacional de transplantes
                  </a>
                </li>
                <li>
                  <a
                    className="boxx"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="http://cetqro.gob.mx/"
                  >
                    Centro Estatal de transplantes de Querétaro
                  </a>
                </li>

                {/* AQUÍ estaba el error: <l> no existe. Debe ser <span> o <div> */}
                <li>
                  <span className="boxx">
                    Hospitales Generales de Querétaro
                    <br />
                    <a
                      style={{ color: "black", cursor: "pointer" }}
                      href="https://maps.app.goo.gl/BwYMJ8qsGCrSJVhYA"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="material-icons tiny">location_on</i> Querétaro
                    </a>
                    <br />
                    <a
                      style={{ color: "black", cursor: "pointer" }}
                      href="https://maps.app.goo.gl/FjuE2NUNZ2AwSb3S6"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="material-icons tiny">location_on</i> San Juan
                      Del Río
                    </a>
                    <br />
                    <a
                      style={{ color: "black", cursor: "pointer" }}
                      href="https://maps.app.goo.gl/VwWtAW8G9iQCQdoH8"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="material-icons tiny">location_on</i> Cadereyta
                    </a>
                    <br />
                    <a
                      style={{ color: "black", cursor: "pointer" }}
                      href="https://maps.app.goo.gl/M2Wbu6LcETCeg1Bx5"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="material-icons tiny">location_on</i> Jalpan
                    </a>
                  </span>
                </li>

                <li>
                  <a
                    className="boxx"
                    href="https://www.seseq.gob.mx/inicio"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sector salud de Querétaro
                  </a>
                </li>
                <li>
                  <a
                    className="boxx"
                    href="https://www.imss.gob.mx/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    IMSS
                  </a>
                </li>
                <li>
                  <a
                    className="boxx"
                    href="https://www.gob.mx/issste"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ISSSTE
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-copyright">
          <div className="container">© 2025 Fundación Soffy</div>
        </div>
      </footer>
    </div>
  );
}
 